import { type AxiosRequestConfig } from 'axios';
import request from '@/utils/ajax';
import { useUserStore } from '@/stores';

/**
 * 构建埋点静默上报配置：
 * 已登录携带 token、未登录不带；失败静默（不弹提示），
 * 且登录过期码不清登录态、不跳登录页，不强制用户登录
 *
 * @param {string} url 上报接口路径
 * @param {Object} data 上报数据
 * @return {AxiosRequestConfig} 请求配置
 */
function trackConfig(url: string, data: unknown): AxiosRequestConfig {
  let token = '';
  try {
    token = useUserStore().token;
  } catch {
    // 极端场景下 pinia 不可用时按未登录处理
  }
  return {
    url,
    method: 'post',
    data,
    params: token ? { token } : undefined,
    addToken: false,
    skipAuthSideEffects: true,
    showToast: false,
  };
}

/**
 * 发送上报数据
 * @param {Object} data
 */
function _track(data: unknown) {
  return request(trackConfig('/exposure/addExposures', data));
}

/**
 * 事件上报
 * @param {Object} params
 * @return {Promise} 上报请求结果，失败时调用方可自行兜底处理
 */
export function track(params: unknown) {
  console.log(`Track exposure data to server: ${JSON.stringify(params)}`);
  return _track(params);
}

/**
 * 停留时间发送数据
 * @param data
 * @returns
 */
export function stay(data: unknown) {
  console.log(`Track stay data to server: ${JSON.stringify(data)}`);
  return request(trackConfig('/stay/addStay', data));
}
